import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Route } from '@app/core/enums/route.enum';
import { inject } from '@angular/core';

const UNRECOVERABLE_ERROR_CODES = ['@ApiClientDependencyUnavailable', '@UserLinkingError'];

export const unrecoverableErrorInterceptor: HttpInterceptorFn = (
  httpRequest: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const router = inject(Router);
    return next(httpRequest).pipe(
      catchError((error) => {
        if (error.status === 500 && UNRECOVERABLE_ERROR_CODES.includes(error.error?.code)) {
          router.navigate([Route.UnrecoverableError], {
            state: { message: error.error?.message },
          });
          throw null;
        } else {
          throw error;
        }
      })
    );
};
